export default class CompetitorStatus {
  constructor (data) {
    this.id = data.id
    this.name = data.nameFr
    this.shortname = data.shortnameFr
  }
}
